import { JSX } from 'react';

import Icon from '@ui/icons/icon';
import { ICONS } from '@ui/icons/types';
import { SortDirection } from './types';
import Button from '../button/button';
import Container from '@ui/container/container';
import { ButtonProps } from '../button/button.types';

type Props = {
  onClick?: () => void;
  sortDirection: SortDirection;
  PreContent?: JSX.Element | (() => JSX.Element);
  PostContent?: JSX.Element | (() => JSX.Element);
  buttonProps?: ButtonProps;
};

const getActiveSortDirectionColor = (sortDirection: SortDirection, iconDirection: SortDirection) => {
  if (sortDirection === iconDirection) {
    return 'var(--primary-500)';
  }
};

export default function SortButton({ onClick, sortDirection, PreContent, PostContent, buttonProps }: Props) {
  return (
    <Button
      clear
      hoverBorder="1px solid var(--gray-400)"
      border="1px solid transparent"
      borderRadius="var(--card-radius)"
      className="flex ai-center jc-center"
      {...buttonProps}
      onClick={buttonProps?.onClick || onClick}
      height={buttonProps?.height ?? '16px'}
      width={buttonProps?.width ?? '24px'}
    >
      {PreContent ? typeof PreContent === 'function' ? <PreContent /> : PreContent : null}

      <Container height="100%" width="100%" className="flex-column ai-center jc-center">
        <Container height="8px" className={`flex ai-center jc-center`}>
          <Icon
            name={ICONS.LITTLE_ARROW_UP}
            size={6}
            color={getActiveSortDirectionColor(sortDirection, SortDirection.up)}
          />
        </Container>
        <Container height="8px" className={`flex ai-center jc-center`}>
          <Icon
            name={ICONS.LITTLE_ARROW_DOWN}
            size={6}
            color={getActiveSortDirectionColor(sortDirection, SortDirection.down)}
          />
        </Container>
      </Container>

      {PostContent ? typeof PostContent === 'function' ? <PostContent /> : PostContent : null}
    </Button>
  );
}
